import React, { useState, useMemo, useRef } from 'react'
import SVG from 'react-inlinesvg'
import { toUnicode } from 'punycode'
import { useOutsideClick, map, isBlank, varClass } from '../shared'

export const filterLabels = {
  'channelUuids': 'Site',
  'networkUuids': 'Network',
  'campaignUuids': 'Site',
  'departments': 'Department',
}

export const departments = [
  { key: 'creator', label: 'Creator' },
  { key: 'sales', label: 'Sales' },
  { key: 'affiliate', label: 'Affiliate' },
]

export const CampaignsFilter = (props) => {
  const { filters, setFilters, channels, networks, departments } = props

  return (
    <div
      className={varClass({
        'subnav-filters': true,
      })}
    >
      {map(filters, (item, index) => (
        <SubnavSelect
          key={item.key}
          index={index}
          {...{
            item,
            channels,
            networks,
            departments,
          }}
          buttonClassName={`filter-button-${item.key}`}
          selected={item.value.split(', ')}
          onSelect={(value, label) => {
            const newFilters = [...filters]
            const filter = newFilters.find((filter) => filter.key === item.key)
            if (filter.value) {
              const splitValue = filter.value.split(', ')
              const splitLabel = filter.label.split(', ')
              const existValue = splitValue.find((v) => v === value)
              if (existValue) {
                filter.value = splitValue.filter((v) => v !== value).join(', ')
                filter.label = splitLabel.filter((l) => l !== label).join(', ')
              } else {
                filter.value += `, ${value}`
                filter.label += `, ${label}`
              }
            } else {
              filter.value = value
              filter.label = label
            }
            setFilters(newFilters)
          }}
          onRemove={() => {
            const newFilters = [...filters]
            newFilters[index].value = ''
            newFilters[index].label = ''
            setFilters(newFilters)
          }}
        />
      ))}
    </div>
  )
}

const SubnavSelect = (props) => {
  const {
    wrapperClassName,
    buttonClassName,
    menuClassName,
    item,
    selected,
    onSelect,
    onRemove,
    channels,
    networks,
    trackers,
    departments,
  } = props

  const [open, setOpen] = useState(false)
  const ref = useRef()
  useOutsideClick(ref, () => {
    setOpen(false)
  })

  const [search, setSearch] = useState('')
  const options = useMemo(() => {
    switch (item.key) {
      case 'channelUuids':
        if (!channels || !Array.isArray(channels)) return {}
        return channels?.reduce((result, channel) => {
          if (channel.channelUuid)
            result[channel.channelUuid] =
              channel.channelName || channel.channelDomain
          return result
        }, {})
      case 'networkUuids':
        if (!networks || !Array.isArray(networks)) return {}
        return networks?.reduce((result, network) => {
          if (network.networkUuid)
            result[network.networkUuid] = network.networkName
          return result
        }, {})
      case 'campaignUuids':
        if (!trackers || !Array.isArray(trackers)) return {}
        return trackers?.reduce((result, tracker) => {
          if (tracker.trackerUuid)
            result[tracker.trackerUuid] = tracker.trackerUrl
          return result
        }, {})
      case 'departments':
        if (!departments || !Array.isArray(departments)) return {}
        return departments?.reduce((result, department) => {
          if (department.key) result[department.key] = department.label
          return result
        }, {})
      default:
        return {}
    }
  }, [item.key])
  const showSearch = Object.keys(options).length > 1
  const shownOptions = useMemo(() => {
    if (search) {
      return Object.keys(options).reduce((result, option) => {
        if (options[option].toLowerCase().indexOf(search.toLowerCase()) !== -1)
          result[option] = options[option]
        return result
      }, {})
    } else {
      return options
    }
  }, [options, search])

  return (
    <div
      className={varClass({
        'subnav-filter': true,
        [wrapperClassName || '']: !!wrapperClassName,
      })}
      ref={ref}
    >
      <button
        className={varClass({
          'filter-button text-primary m-r-15 merchant-filter-button': true,
          'active': open,
          [buttonClassName || '']: !!buttonClassName,
        })}
        onClick={() => setOpen(!open)}
      >
        <>
          {filterLabels[item.key]}:{' '}
          <b className="m-l-1">{item.label || 'All'}</b>
        </>
        <SVG
          src="/images/chevron-down.svg"
          className={varClass({
            'm-l-1': true,
            'rotate-180': open,
          })}
        />
      </button>
      <div
        className={varClass({
          'submenu': true,
          'shown': open,
          [menuClassName || '']: !!menuClassName,
        })}
      >
        {showSearch && (
          <div className="control control-focusless">
            <SVG src="/images/icon-search.svg" />
            <input
              type="text"
              placeholder={`Find ${filterLabels[item.key].toLowerCase()}`}
              value={search}
              onChange={(event) => setSearch(event.target.value)}
            />
          </div>
        )}
        <ul>
          {map(shownOptions, (value) => (
            <li
              key={value}
              title={toUnicode(options[value])}
              className={varClass({
                'selected': selected.includes(value),
              })}
              onClick={() => {
                onSelect(value, toUnicode(options[value]))
                setOpen(false)
              }}
            >
              {toUnicode(options[value])}
            </li>
          ))}
          {isBlank(shownOptions) && (
            <li className="text-light text-bold text-center inactive">
              Nothing found
            </li>
          )}
        </ul>
        {selected?.length && (
          <button
            className="remove-btn link"
            onClick={() => {
              onRemove()
              setOpen(false)
            }}
          >
            <SVG src="/images/icon-trash.svg" className="m-r-2" />
            Remove filter
          </button>
        )}
      </div>
    </div>
  )
}
